module.exports = __webpack_public_path__ + "static/media/instagram.4f7cb5fb.png";